import { Route } from '@angular/router';
import { authGuard, publicOnlyGuard } from '@shared-data-access';

export const appRoutes: Route[] = [
  // Ruta por defecto - Redireccionar a login
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  
  // Ruta de autenticación - Login (SIN layout)
  {
    path: 'login',
    canActivate: [publicOnlyGuard],
    loadComponent: () => 
      import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  
  // Rutas con layout (dashboard, módulos, etc.)
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout-wrapper.component').then(m => m.LayoutWrapperComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'gestionar-guia',
        loadComponent: () =>
          import('./features/manage-guide/manage-guide.component').then(
            m => m.ManageGuideComponent
          )
      },
      {
        path: 'sobres',
        loadComponent: () =>
          import('./features/envelopes/envelopes.component').then(
            m => m.EnvelopesComponent
          )
      },
      {
        path: 'encomiendas',
        loadComponent: () =>
          import('./features/parcels/parcels.component').then(
            m => m.ParcelsComponent
          )
      },
      {
        path: 'personal',
        loadComponent: () =>
          import('./features/staff/staff.component').then(
            m => m.StaffComponent
          )
      },
      {
        path: 'rutas-domicilio',
        loadComponent: () =>
          import('./features/home-routes/home-routes.component').then(
            m => m.HomeRoutesComponent
          )
      },
      {
        path: 'vehiculos',
        loadComponent: () =>
          import('./features/vehicles/vehicles.component').then(
            m => m.VehiclesComponent
          )
      },
      {
        path: 'localidades',
        loadComponent: () =>
          import('./features/locations/locations.component').then(
            m => m.LocationsComponent
          )
      },
      {
        path: 'soporte',
        loadComponent: () =>
          import('./features/support/support.component').then(
            m => m.SupportComponent
          )
      },
      {
        path: 'reportes',
        loadComponent: () =>
          import('./features/reports/reports.component').then(
            m => m.ReportsComponent
          )
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./features/change-password/change-password.component').then(
            m => m.ChangePasswordComponent
          )
      },
      {
        path: 'chat/:id',
        data: { kind: 'staff' },
        loadComponent: () =>
          import('@shared-data-access/services/inbox/chat-thread.component').then(
            (m) => m.ChatThreadComponent,
          ),
      },
    ]
  },
  
  // Ruta 404 - Redireccionar a login (temporalmente)
  {
    path: '**',
    redirectTo: 'login'
  }
];
